

const Treinamento = ({nomeDoCurso, link}) => {
  return (
    <div>
        <a href={link}>{nomeDoCurso}</a>
    </div>
  )
}

export default Treinamento